import { render, staticRenderFns } from "./vue-particles.vue?vue&type=template&id=25a8b2db&"
import script from "./vue-particles.vue?vue&type=script&lang=js&"
export * from "./vue-particles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports